import { render, staticRenderFns } from "./GoPOSTicketTemplate.vue?vue&type=template&id=104191b4"
import script from "./GoPOSTicketTemplate.vue?vue&type=script&lang=js"
export * from "./GoPOSTicketTemplate.vue?vue&type=script&lang=js"
import style0 from "./GoPOSTicketTemplate.vue?vue&type=style&index=0&id=104191b4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports